import clsx from 'clsx';
import React from 'react';

interface MobileStepDotsProps {
  className?: string;
  step: number;
  totalSteps: number;
}

const MobileStepDots = ({ className, step, totalSteps }: MobileStepDotsProps) => {
  return (
    <div
      className={clsx('flex items-center justify-center gap-6', className)}
      role="tablist"
      aria-label={`Step ${step} of ${totalSteps}`}
    >
      {Array.from({ length: totalSteps }, (_, i) => {
        const isActive = i + 1 === step;
        return (
          <span
            key={i}
            role="tab"
            aria-current={isActive ? 'step' : undefined}
            aria-label={isActive ? `Step ${step}` : `Step ${i + 1}`}
            className={clsx(
              'h-10 w-10 shrink-0 rounded-full transition-colors',
              isActive ? 'bg-pro-gold' : 'border border-solid border-grayscale-beige bg-transparent'
            )}
          />
        );
      })}
    </div>
  );
};

export default MobileStepDots;
